import style from './map.module.scss';
import React, {useEffect, useState} from 'react';
import {GoogleMap, LoadScript} from '@react-google-maps/api';
import {connect} from "react-redux";
import {getDevicesByMap} from "../../thunk/device";
import SearchBox from "./searchBox";
import InfoWindowMap from "./infoWindow";
import InfoWindowMapGdacs from "./infoWindowGdacs";
import WindParticles from "./WindParticles";


const MAP_LIBRARIES = ["places", "drawing"];
const KEY_OWM = "28417a9dfb12d4168ed8fb3033546e84";
const LAYER_LEGENDS = {
    wind: {
        title: 'Wind',
        minLabel: '0 m/s',
        maxLabel: '50+ m/s'
    },
    temperature: {
        title: 'Temperature',
        minLabel: '-40°C',
        maxLabel: '40+°C'
    },
    precipitation: {
        title: 'Precipitation',
        minLabel: '0 mm/h',
        maxLabel: '50+ mm/h'
    },
    clouds: {
        title: 'Clouds',
        minLabel: '0%',
        maxLabel: '100%'
    },
    pressure: {
        title: 'Pressure',
        minLabel: '950 hPa',
        maxLabel: '1050+ hPa'
    }
};
function Map({
                 modeMap,
                 page,
                 getDevicesByMap,
                 activeTab,
                 loadData
             }) {
    const [center, setCenter] = useState({
        lat: 32.06896,
        lng: 34.77583
    });
    const [zoom, setZoom] = useState(13);

    const [containerStyle, setContainerStyle] = useState({
        width: '100%',
        height: '100%'
    });
    const [mapRef, setMapRef] = useState(null);
    const [layers, setLayers] = useState(null);
    const [activeLayerKey, setActiveLayerKey] = useState(null);
    const [isWindParticles, setIsWindParticles] = useState(false);

    const onMapLoad = (map) => {
        setMapRef(map);
        // const maps = window.google?.maps;
        // if (!maps) {
        //     return;
        // }

        map.setOptions({
            mapTypeControl: false,
            mapTypeControlOptions: {
                position: 10,
                // style: maps.MapTypeControlStyle.DEFAULT,
            },
        });

        const windLayerNew = createOWMLayer('wind_new');
        const windLayer = createOWMLayer('wind');
        const precipitationLayer = createOWMLayer('precipitation');
        const cloudsLayer = createOWMLayer('clouds');
        const pressureLayer = createOWMLayer('pressure');
        const temperatureLayer = createOWMLayer('temp_new');

        if (windLayerNew || windLayer || precipitationLayer || cloudsLayer || pressureLayer || temperatureLayer) {
            setLayers({
                // wind: [windLayerNew, windLayer],
                wind: [windLayer],
                precipitation: precipitationLayer,
                clouds: cloudsLayer,
                pressure: pressureLayer,
                temperature: temperatureLayer,
            });
        }

    };

    useEffect(() => {
        if (activeTab === "aqi") {
                const quat = JSON.stringify([[center.lat + 0.045, center.lng - 0.045],[center.lat - 0.045, center.lng + 0.045]]);//[[top left], [bottom right]]
                // getDevicesByMap({center: JSON.stringify([center.lat, center.lng]), coordinates: quat});
                // getDevicesByMap({center: JSON.stringify([center.lat, center.lng])});
        }
    }, [center, getDevicesByMap]);

    useEffect(() => {
        if (activeTab === "aqi") {
            setCenter({
                lat: 32.06896,
                lng: 34.77583
            });
            setZoom(13);
        } else if (activeTab === "gdacs") {
            setCenter({
                lat: 0,
                lng: 0
            });
            setZoom(2);
        }
    }, [activeTab]);

    // const onMapLoad = useCallback((map: google.maps.Map) => {
    //     addWindLayer(map);
    // }, []);

    // const addWindLayer = (map) => {
    //     if (!window.google?.maps) {
    //         return;
    //     }

    //     const windLayer = new window.google.maps.ImageMapType({
    //         getTileUrl: (coord, zoom) => {
    //         return `https://tile.openweathermap.org/map/wind_new/${zoom}/${coord.x}/${coord.y}.png?appid=${KEY_OWM}`;
    //         },
    //         tileSize: new window.google.maps.Size(256, 256),
    //         name: 'Wind',
    //         opacity: 1,
    //     });

    //     map.overlayMapTypes.insertAt(0, windLayer);
    // };

    const createOWMLayer = (type) => {
        if (!window.google?.maps) {
            return null;
        }

        return new window.google.maps.ImageMapType({
            // Формируем URL тайла по шаблону OWM: тип слоя, зум и координаты тайла.
            // coord.x/coord.y — индексы тайла в сетке, zoom — уровень приближения.
            // KEY_OWM передается в query string как appid для авторизации.
            getTileUrl: (coord, zoom) =>
                `https://tile.openweathermap.org/map/${type}/${zoom}/${coord.x}/${coord.y}.png?appid=${KEY_OWM}`,
            // Размер тайла для карт OWM фиксированный — 256x256 пикселей.
            tileSize: new window.google.maps.Size(256, 256),
            // Прозрачность оверлея (1 = полностью непрозрачный).
            opacity: 1,
        });
    };

    const setLayer = (map, layer) => {
        map.overlayMapTypes.clear();
        if (Array.isArray(layer)) {
            layer.filter(Boolean).forEach(item => map.overlayMapTypes.push(item));
            return;
        }
        if (layer) {
            map.overlayMapTypes.push(layer);
        }
    };

    const handleLayerToggle = (layerKey, layerValue) => {
        if (!mapRef) {
            return;
        }
        if (activeLayerKey === layerKey) {
            setLayer(mapRef, null);
            setActiveLayerKey(null);
            return;
        }
        setLayer(mapRef, layerValue);
        setActiveLayerKey(layerKey);
    };

    return (
        <div className={[style.mapRow, page.currentItem.active ? style.active : "", `${style[modeMap]}`].join(" ")}>
            {/* {mapRef && layers && (
                <div style={{position: 'absolute', top: '50%', right: 10, zIndex: 1000, display: 'flex', flexDirection: 'column', gap: 8}}>
                    {layers.wind && <button onClick={() => {setLayer(mapRef, layers.wind); setIsWindParticles(true);}}>🌬 Wind</button>}
                    {layers.precipitation && <button onClick={() => {setLayer(mapRef, layers.precipitation); setIsWindParticles(false);}}>☔ Осадки</button>}
                    {layers.clouds && <button onClick={() => {setLayer(mapRef, layers.clouds); setIsWindParticles(false);}}>☁️ Облачность</button>}
                    {layers.pressure && <button onClick={() => {setLayer(mapRef, layers.pressure); setIsWindParticles(false);}}>🧭 Давление</button>}
                    {layers.temperature && <button onClick={() => {setLayer(mapRef, layers.temperature); setIsWindParticles(false);}}>🌡️ Температура</button>}
                </div>
            )} */}
            {mapRef && layers && (
                <div className={style.layerButtons}>
                    {layers.wind && (
                        <button
                            className={[style.layerButton, activeLayerKey === 'wind' ? style.layerButtonActive : ""].join(" ")}
                            onClick={() => handleLayerToggle('wind', layers.wind)}
                        >
                            Wind
                        </button>
                    )}
                    {layers.precipitation && (
                        <button
                            className={[style.layerButton, activeLayerKey === 'precipitation' ? style.layerButtonActive : ""].join(" ")}
                            onClick={() => handleLayerToggle('precipitation', layers.precipitation)}
                        >
                            Precipitation
                        </button>
                    )}
                    {layers.clouds && (
                        <button
                            className={[style.layerButton, activeLayerKey === 'clouds' ? style.layerButtonActive : ""].join(" ")}
                            onClick={() => handleLayerToggle('clouds', layers.clouds)}
                        >
                            Clouds
                        </button>
                    )}
                    {layers.pressure && (
                        <button
                            className={[style.layerButton, activeLayerKey === 'pressure' ? style.layerButtonActive : ""].join(" ")}
                            onClick={() => handleLayerToggle('pressure', layers.pressure)}
                        >
                            Pressure
                        </button>
                    )}
                    {layers.temperature && (
                        <button
                            className={[style.layerButton, activeLayerKey === 'temperature' ? style.layerButtonActive : ""].join(" ")}
                            onClick={() => handleLayerToggle('temperature', layers.temperature)}
                        >
                            Temperature
                        </button>
                    )}
                </div>
            )}
            {mapRef && layers && LAYER_LEGENDS[activeLayerKey] && (
                <div className={style.layerLegend}>
                    <div className={style.layerLegendTitle}>{LAYER_LEGENDS[activeLayerKey].title}</div>
                    <div className={[style.layerLegendScale, style[`legend${activeLayerKey}`]].join(" ")} />
                    <div className={style.layerLegendLabels}>
                        <span>{LAYER_LEGENDS[activeLayerKey].minLabel}</span>
                        <span>{LAYER_LEGENDS[activeLayerKey].maxLabel}</span>
                    </div>
                </div>
            )}
            <LoadScript
                googleMapsApiKey={"AIzaSyCupV2uK4EQSM_yWbe9BJoLF75zKZyhRcw"}
                id={'google-map-script'}
                libraries={MAP_LIBRARIES}
            >
                <div style={{position: 'relative', width: '100%', height: '100%'}}>
                    <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={center}
                        zoom={zoom}
                        language="he"
                        onLoad={onMapLoad}
                    >
                        <SearchBox
                            center={center}
                            setCenter={setCenter}
                            getDevicesByMap={getDevicesByMap}
                        />
                        {loadData && activeTab === "aqi"  && <InfoWindowMap/> || ""}
                        {loadData && activeTab === "gdacs" && <InfoWindowMapGdacs/> || ""}
                    </GoogleMap>
                    <WindParticles mapRef={mapRef} isActive={isWindParticles} apiKey={KEY_OWM} />
                </div>
            </LoadScript>


        </div>);

}

const mapStateToProps = state => ({
    page: state.page,
    activeTab: state.page.activeTab,
    loadData: state.page.loadData
});

const mapDispatchToProps = dispatch => ({
    getDevicesByMap: data => dispatch(getDevicesByMap(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(Map);